import { Route, Routes } from 'react-router-dom';

import { store } from '@campaign/domain/store';
import { Page } from '@campaign/view/components/Page';
import { CampaignDetail } from '@campaign/view/pages/CampaignDetail';
import { CampaignList } from '@campaign/view/pages/CampaignList';
import { NotFound } from '@campaign/view/pages/NotFound';

export function App() {
  return (
    <Page store={store}>
      <Routes>
        <Route path="/" element={<CampaignList />} />
        <Route
          path="/campaignDetail/:organizationId/:id"
          element={<CampaignDetail />}
        />
        <Route path="/notFound" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Page>
  );
}
